var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"color":_vm.count > 0 ? 'green' : 'error',"inline":"","dot":""}})}
var staticRenderFns = []

export { render, staticRenderFns }